import { render } from "./EatingStatusItem.vue?vue&type=template&id=b9ce4420&scoped=true&ts=true"
import script from "./EatingStatusItem.vue?vue&type=script&lang=ts"
export * from "./EatingStatusItem.vue?vue&type=script&lang=ts"

import "./EatingStatusItem.vue?vue&type=style&index=0&id=b9ce4420&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ce4420"]])

export default __exports__